<script setup lang="ts">
import { IOpenCustomization } from '~/lib/models/events'
import { OptionsGroupsMain, productInfoKey } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  optionGroup: OptionsGroupsMain
}>()

const emit = defineEmits<{
  (e: 'open-customization', payload: IOpenCustomization): void
}>()

const productInfo = inject(productInfoKey)!

const { t } = useLocale()
const { translateInterpolated } = useTranslation()
const { trackCustomizeIngredients } = useGTM()

const customizationString = computed(() =>
  translateInterpolated(getProductCustomizationResume([props.optionGroup]))
)

const emitOpenCustomization = (payload: IOpenCustomization) => {
  const { identifier: id, title } = props.optionGroup
  emit('open-customization', payload)
  trackCustomizeIngredients(productInfo, { id, name: title })
}
</script>

<template>
  <div class="mb-4">
    <div class="flex w-full flex-col gap-2">
      <p class="text-sm font-bold">{{ optionGroup.title }}</p>

      <p
        v-if="optionGroup.options.length"
        class="cursor-pointer text-xs text-mcd-secondaryDarkGrey underline"
        @click="($ev: MouseEvent) => emitOpenCustomization({event: $ev as PointerEvent, optionsGroups: [optionGroup], openedComponent: {
          id: optionGroup.identifier,
          name: optionGroup.title
        }})"
      >
        {{ t('productDetail.customization.actions.customize') }}
      </p>

      <!-- Personalization string -->
      <p
        v-dompurify-html="customizationString"
        class="line-clamp-2 text-xs text-mcd-secondaryDarkGrey"
      ></p>
    </div>
  </div>
</template>
